import React from 'react';
import Button from "@material-ui/core/Button";

export default function ContainedButtons(props) {
        return (
            <Button
                variant={props.variant}
                disabled={props.disabled}
                color={props.color}
                className={props.className}
                type={props.type}
                style={props.style}
                onClick={props.onClick}
            >
                {props.textLabel}
            </Button>
        );
    }
